import React, { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
} from "@mui/material";
import emptyCartImage from "../../../assets/empty-cart.png"; // 🧺 <-- use your image path

const EmptyCartDialog = ({openEmptyCart,setOpenEmptyCart,handleEmpty,clearPreCart}) => {


  const handleClose = () => setOpenEmptyCart(false);
 

  return (
    <Dialog
      open={openEmptyCart}
      onClose={handleClose}
      PaperProps={{
        sx: {
          borderRadius: 4,
          p: 2,
          textAlign: "center",
          width: 340,
        },
      }}
    >
      <DialogContent>
        <Box display="flex" flexDirection="column" alignItems="center" gap={1}>
          {/* Custom Image */}
          <Box
            sx={{
              width: 120,
              height: 120,
              position: "relative",
              mb: 1,
            }}
          >
            <img
              src={emptyCartImage}
              alt="Empty Cart"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "contain",
              }}
            />
          </Box>

          <Typography
            variant="h6"
            sx={{ fontWeight: 700, color: "#E65100", mt: 1 }}
          >
            Empty Cart?
          </Typography>

          <Typography
            variant="body2"
            sx={{ color: "#555", mt: 1, lineHeight: 1.4 }}
          >
            Are you sure you want to <b>remove all items</b> from your cart?
          </Typography>
        </Box>
      </DialogContent>

      <DialogActions sx={{ justifyContent: "center", mb: 1 }}>
        <Button
          variant="outlined"
          color="success"
          onClick={clearPreCart}
          sx={{
            textTransform: "none",
            borderRadius: 2,
            fontWeight: 600,
            px: 3,
          }}
        >
          Empty Cart
        </Button>
        <Button
          variant="contained"
          color="success"
          onClick={handleClose}
          sx={{
            textTransform: "none",
            borderRadius: 2,
            fontWeight: 600,
            px: 3,
            bgcolor: "#00A86B",
            "&:hover": { bgcolor: "#009A60" },
          }}
        >
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EmptyCartDialog;
